import { Color3, FreeCamera, Scene, SpotLight, Vector3 } from "@babylonjs/core";

export interface HeadlampConfig { readonly angleDegrees: number; readonly range: number; readonly intensity: number; }
export const HEADLAMP_CONFIGS: Readonly<Record<"low" | "medium" | "high", HeadlampConfig>> = {
  low: { angleDegrees: 30, range: 14, intensity: 4.1 },
  medium: { angleDegrees: 32, range: 17, intensity: 4.7 },
  high: { angleDegrees: 34, range: 19, intensity: 5.1 },
};
export const FLASHLIGHT_BEAM_ANGLE = HEADLAMP_CONFIGS.medium.angleDegrees * Math.PI / 180;

export class HeadlampController {
  readonly light: SpotLight;
  readonly config: HeadlampConfig;
  private intensityMultiplier = 1;
  constructor(scene: Scene, camera: FreeCamera, quality: "low" | "medium" | "high") {
    this.config = HEADLAMP_CONFIGS[quality];
    this.light = new SpotLight("headlamp-beam", new Vector3(0, -0.05, 0.12), Vector3.Forward(), this.config.angleDegrees * Math.PI / 180, 7, scene);
    this.light.parent = camera;
    this.light.diffuse = new Color3(1, 0.86, 0.68);
    this.light.specular = new Color3(0.62, 0.55, 0.44);
    this.light.intensity = this.config.intensity;
    this.light.range = this.config.range;
  }
  setIntensityMultiplier(multiplier:number):void{this.intensityMultiplier=Math.max(0,Math.min(1,multiplier));this.light.intensity=this.config.intensity*this.intensityMultiplier;}
  get currentIntensityMultiplier():number{return this.intensityMultiplier;}
  get configuredIntensity():number{return this.config.intensity;}
  get effectiveIntensity():number{return this.light.intensity;}
  update(): void { /* Camera parenting keeps position and direction synchronized without a visible model. */ }
}
